export default "/list/static/images/eg-logo.svg";